{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Valitse kohde",
  "tableResizer": "Koon muuttaja",
  "expand": "Expand",
  "collapse": "Collapse",
  "colorSwatchPicker": "Color swatches"
}
